const items = [
    {
        id: 1,
        img: `${process.env.PUBLIC_URL}/images/pic04.png`,
        github: "https://github.com/StartingLine-FM/StartingLine.Fm",
        website: "https://startinglineapp.com/",
        title: "StartingLine.FM",
        description: "What began as a client project with 3 other classmates during my time at EDA, has now become continued work post-graduation with 1 of those classmates through EDA's Co-Op program. We were tasked by the NDSU Center for Entrepreneurship and Family Business to create StartingLine.FM: An online hub for entrepreneurial growth in the FMWF area. This app aims to pool local resources for business growth into one app where users can filter by applicable business stage and category, and includes to-do list functionality as well as a calendar of relevant local events. I was responsible for the full-stack development of the search functions and initial landing page, as well as some of the to-do list functionality for unregistered users."
    },
    {
        id: 2,
        img: `${process.env.PUBLIC_URL}/images/pic01.png`,
        github: 'https://github.com/PizzaPadawan/the-deprogrammer-solo-project',
        website: null,
        title: "The Deprogrammer",
        description: "A playlist editor and gameplay companion app for the Deprogrammed podcast. This was my solo project during EDA that included a week of planning and 2 weeks of development. Users can edit a list of songs for an artist down to a top 20 and 'play' the Deprogrammed game: where a panel of 3-4 judges determines an artist's top 10 songs."
    },
    {
        id: 3,
        img: `${process.env.PUBLIC_URL}/images/pic03.png`,
        title: "Gallery of my Life",
        github: 'https://github.com/PizzaPadawan/react-gallery',
        website: 'https://react-gallery.fly.dev/',
        description: "A simple Instagram-style CRUD app where users can click on posted images to see captions, as well as posting images and captions, adding 'likes' to images, and deleting items. This was our weekend project during React week. After graduation, I went back in and rewrote this in TypeScript to get some practice on that, as well as updating it to use Redux state for any user-made changes to avoid any permanent alterations on the hosted site."
    },
    {
        id: 4,
        img: `${process.env.PUBLIC_URL}/images/pic02.png`,
        github: 'https://github.com/PizzaPadawan/movie-sagas',
        website: null,
        title: "the movies saga",
        description: 'An app for logging and storing a movie collection. Users can add and edit movies, as well as click on the posters on the main gallery page to view details for that movie. This was a weekend project to show off everything we learned during the week we first covered Redux Sagas.'
    }
]

export default items;